export default "__VITE_ASSET__Lxl3TG6l__"